/**
 * Tiny platform helper — lets components branch on web vs native (Capacitor)
 * without importing Capacitor directly throughout the app.
 *
 * Capacitor injects a global `window.Capacitor` only inside the native iOS/Android
 * shell, so this works at runtime without bundling anything Capacitor-specific
 * into the web build.
 */
export const isNativeApp = () => {
  if (typeof window === "undefined") return false;
  const cap = window.Capacitor;
  return !!(cap && typeof cap.isNativePlatform === "function" && cap.isNativePlatform());
};

export const nativePlatform = () => {
  if (typeof window === "undefined") return "web";
  const cap = window.Capacitor;
  if (!cap || typeof cap.getPlatform !== "function") return "web";
  const p = cap.getPlatform();
  return p === "ios" || p === "android" ? p : "web";
};
